import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      width: 'calc(100% - 13px)',
      borderTop: '1px solid #EBEBEB',
      '&:last-of-type': {
        borderBottom: '1px solid #EBEBEB',
      },
      '& input': {
        padding: 5,
      },
    },
    box__inner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 23,
      width: '100%',
      padding: '5.5px 0',
      minHeight: 45,
    },
  })
)
export default useStyles
